import React from 'react';

import { flagStyles } from '../settings';

const SvgTN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5280px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTN;
